@for (blogEntry of blogEntries; track blogEntry) {
<div class="row mb-4">
  <div class="col">
    <tvoed-blog-entry [blogEntry]="blogEntry"></tvoed-blog-entry>
  </div>
</div>
}
